var _defs, _g, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;stroke:#000;stroke-linecap:square;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 382.5,
    cy: 332,
    r: 18.23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.5,314.27c9.78,0,17.73,7.96,17.73,17.73s-7.96,17.73-17.73,17.73-17.73-7.96-17.73-17.73,7.96-17.73,17.73-17.73m0-1c-10.35,0-18.73,8.39-18.73,18.73s8.39,18.73,18.73,18.73,18.73-8.39,18.73-18.73-8.39-18.73-18.73-18.73h0Z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 376.94,
    y1: 326.26,
    x2: 388.26,
    y2: 337.57
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 388.26,
    y1: 326.26,
    x2: 376.94,
    y2: 337.57
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCross);
export default __webpack_public_path__ + "static/media/close-cross.d5d87cd8ebf09e71ced397e5d949653e.svg";
export { ForwardRef as ReactComponent };